import { Props } from "."

export const mockProps: Props = {
  title: "Lorem ipsum dolor sit amet, consectetur adipiscing",
  text: "Phasellus vitae leo ipsum. Nulla vitae magna non velit congue tristique non in nulla. Lorem ipsum dolor sit amet, consectetur adipiscing. Phasellus vitae leo ipsum. Nulla vitae magna non velit congue tristique non in nulla.",
  variant: "info",
  links: [
    { label: "Read more", href: "#" },
    { label: "Dismiss", onClick: () => {} },
  ],
  className: "drop-shadow max-w-[400px]",
}
